import { ChevronRight } from 'lucide-react';
import { FontWeight, Heading } from '@lili/lili-frontend-common';
import type React from 'react';

interface OptionStripProps {
  icon?: React.ReactNode;
  title: string;
  selected?: boolean;
  onClick: () => void;
}

export const OptionStrip = ({ icon, title, selected, onClick }: OptionStripProps) => {
  return (
    <button
      onClick={onClick}
      className={`flex items-center bg-text-main-primary-inverse justify-between w-full p-[16px] rounded-[12px] border ${
        selected ? 'border-surface-brand-action-03' : 'border-surface-primary-bw-03'
      } hover:border-surface-brand-action-03 transition-colors`}>
      <div className='flex items-center gap-[10px]'>
        {icon && icon}
        <Heading.H9 fontWeight={FontWeight.MEDIUM} className='text-text-main-primary'>
          {title}
        </Heading.H9>
      </div>
      <ChevronRight className='text-text-main-secondary' size={20} />
    </button>
  );
};
